import React from 'react';

import dynamic from 'next/dynamic';

import { MultiCardV2 } from '@/types/generated'; // <--- Import the specific type

const MultiCardVariantOne = dynamic(() => import('./variantOne'));
const MultiCardVariantTwo = dynamic(() => import('./variantTwo'));

const MultiCardV2Loader: React.FC<MultiCardV2> = ({ variant, ...props }) => {
	if (variant === 'TeamTag' || variant === 'TeamTag3') {
		return <MultiCardVariantOne {...props} variant={variant} />;
	} else {
		return <MultiCardVariantTwo {...props} variant={variant} />;
	}
};

export default MultiCardV2Loader;
